export enum OrganizationConfigurationTabs {
  MACHINES = 'machines',
  USERS = 'users',
  CONTACTS = 'contacts',
  CONSTANTS = 'constants',
  SETTINGS = 'settings',
  BRANDING = 'branding',
  MAIL = 'mail-templates',
}
